import { parse } from "fast-xml-parser";
import { render, h } from "preact";
import { useState } from "preact/hooks";

window.addEventListener("load", async () => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("database") === null) {
        const output = <div>
            <h1>Wybierz bazę danych:</h1>
            <ul>
                <li><a href="?database=nso-polkard-2020">NSO / Polkard 2020</a></li>
                <li><a href="?database=rwpm13-2022">Działanie 13.2 Ochrona zdrowia, w tym na Doposażenie podmiotów w nowoczesny sprzęt i aparaturę medyczną i diagnostyczną, w tym do rehabilitacji leczniczej dla pacjentów, którzy przeszli COVID-19 - Warmińsko - Mazurskie - 2022</a></li>
                <li><a href="?database=rpld10-2022">Poddziałanie X.3.1 Programy z uwzględnieniem rehabilitacji medycznej ułatwiające powroty do pracy oraz umożliwiające wydłużenie aktywności zawodowej - Łódzkie - 2022</a></li>
            </ul>
        </div>
        
        render(output, document.getElementById("app") as HTMLDivElement);
        return;
    }

    const database = urlParams.get("database") || "";

    if (urlParams.get("ksiega")) {
        displayKsiega(urlParams.get("ksiega") as string, database);
        return;
    }
    else if (urlParams.get("summary")) {
        const progressValue = new ProgressValue(0.0, 1.0);

        render(<Progress value={progressValue}/>, document.getElementById("app") as HTMLDivElement);

        const json = await loadKsiegaList(database, progressValue);

        const output = <div>
            <table>
                {Object.entries(json).map(([key, value]) => {
                    return <tr>
                        <td>
                            {value["typ:Dzial1"]["typ:FirmaImieNazwiskoPodmiotu"]}
                        </td>
                        <td>
                        <a href={`?database=${database}&ksiega=${encodeURIComponent(value["url"])}`}>{new URL(`${location.origin}${location.pathname}?database=${database}&ksiega=${encodeURIComponent(value["url"])}`).href}</a>
                        </td>
                    </tr>;
                })}
            </table>
        </div>;

        render(output, document.getElementById("app") as HTMLDivElement);
        return;
    }
    else if (urlParams.get("displayAll")) {
        const progressValue = new ProgressValue(0.0, 1.0);

        render(<Progress value={progressValue}/>, document.getElementById("app") as HTMLDivElement);

        displayAllKsiega(progressValue, database);
    }
    else {
        const progressValue = new ProgressValue(0.0, 1.0);
        render(<Progress value={progressValue}/>, document.getElementById("app") as HTMLDivElement);

        const json = await loadKsiegaList(database, progressValue);

        const output = <div>
            <div><a href={`.`}>Wróć do listy baz danych</a></div>
            <div><a href={`?database=${database}&summary=true`}>Nazwy podmiotów wraz z adresami</a></div>
            <div><a href={`?database=${database}&displayAll=true`}>Wszystkie księgi podmiotów</a></div>
            {Object.entries(json).map(([key, value]) => {
                return <div>
                    <a href={`?database=${database}&ksiega=${encodeURIComponent(`${value["url"]}`)}`}>{key} - {value["typ:Dzial1"]["typ:FirmaImieNazwiskoPodmiotu"]}</a>
                </div>;
            })}
        </div>;

        render(output, document.getElementById("app") as HTMLDivElement);

        return;
    }
});

class ProgressValue {
    private value: number;
    private _max: number;

    public onUpdate?: () => void;

    get max() {
        return this._max;
    }

    set max(value: number) {
        this._max = value;

        if (this.onUpdate) {
            this.onUpdate();
        }
    }

    get percentage() {
        return this.value / this._max;
    }

    constructor(value: number, max: number) {
        this.value = value;
        this._max = max;
    }

    update(value: number) {
        this.value = value;

        if (this.onUpdate) {
            this.onUpdate();
        }
    }

    increment(value: number) {
        this.update(this.value + value);
    }
}

function Progress(props: { value: ProgressValue }) {
    const [progress, setProgress] = useState(props.value.percentage);

    props.value.onUpdate = () => {
        setProgress(props.value.percentage);
    }

    return <div>
        <div>Loading...</div>
        <progress value={progress} max={1.0}></progress>
    </div>
}

async function displayAllKsiega(progress: ProgressValue, database: string) {
    const json = await loadKsiegaList(database, progress);

    console.log(json);

    const output = <div>
        <div>
            <h3><label style="cursor: pointer" for="emailaddresslist">Adresy email wszystkich placówek i jednostek (kliknij aby rozwinąć)</label></h3>
            <input type="checkbox" style="display: none" id="emailaddresslist"/>
            <div>
            {Object.entries(json).map(([key, value]) => {
                const content: any = value;
                return <EmailAddresses data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
            })}
            </div>
        </div>
        <div>
            <h3><label style="cursor: pointer" for="phonenumberlist">Numery telefonów wszystkich placówek i jednostek (kliknij aby rozwinąć)</label></h3>
            <input type="checkbox" style="display: none" id="phonenumberlist"/>
            <div>
                {Object.entries(json).map(([key, value]) => {
                    const content: any = value;
                    return <PhoneNumbers data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
                })}
            </div>
        </div>
        {Object.entries(json).map(([key, value]) => {
            const content: any = value;

            return <div>
                <h1>{content["typ:Dzial1"]["typ:FirmaImieNazwiskoPodmiotu"]}</h1>
                <Podmiot data={content["typ:Dzial1"]}/>
                <h2>Jednostki</h2>
                <JednostkaList data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
                <h2>Adresy email</h2>
                <EmailAddresses data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
                <h2>Telefony</h2>
                <PhoneNumbers data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>

                {/* <div class="jednostka-list">
                    {(content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"] as {}[]).map((el) => <Jednostka data={el}/>)}
                </div> */}
                {/* <h1>Dzial2 - Komórki</h1>
                <KomorkaList data={content["typ:Dzial3"]["typ:ListaKomorek"]["typ:Komorka"]}/> */}
                {/* <div class="komorka-list">
                    {(content["typ:Dzial3"]["typ:ListaKomorek"]["typ:Komorka"] as {}[]).map((el) => <Komorka data={el}/>)}
                </div> */}
            </div>
        })}
    </div>;

    render(output, document.getElementById("app") as HTMLDivElement);
}

async function displayKsiega(ksiega: string, database: string) {
    const content = await loadKsiega(ksiega, database);

    console.log(content);

    const output = <div>
        <div>
            <h1>{content["typ:Dzial1"]["typ:FirmaImieNazwiskoPodmiotu"]}</h1>
            <Podmiot data={content["typ:Dzial1"]}/>
            <h2>Jednostki</h2>
            <JednostkaList data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
            <h2>Adresy email</h2>
            <EmailAddresses data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>
            <h2>Telefony</h2>
            <PhoneNumbers data={content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"]}/>

            {/* <div class="jednostka-list">
                {(content["typ:Dzial2"]["typ:ListaJednostek"]["typ:Jednostka"] as {}[]).map((el) => <Jednostka data={el}/>)}
            </div> */}
            {/* <h1>Dzial2 - Komórki</h1>
            <KomorkaList data={content["typ:Dzial3"]["typ:ListaKomorek"]["typ:Komorka"]}/> */}
            {/* <div class="komorka-list">
                {(content["typ:Dzial3"]["typ:ListaKomorek"]["typ:Komorka"] as {}[]).map((el) => <Komorka data={el}/>)}
            </div> */}
        </div>
    </div>;

    render(output, document.getElementById("app") as HTMLDivElement);
}

async function loadKsiegaList(database: string, progress: ProgressValue): Promise<any> {
    const response = await fetch("ksiegi/" + database + "/list.json");
    const list = await response.json();
    const result: any = {};
    const promises = [];

    progress.update(0);

    for (let i = 0; i < list.length; i++) {
        promises.push(new Promise(async (resolve) => {
            const ksiega = await loadKsiega(list[i], database);

            ksiega["url"] = list[i];
            result[ksiega["typ:Dzial1"]["typ:NumerKsiegi"]] = ksiega;
            progress.increment(1);
            resolve();
        }));
    }

    progress.max = promises.length;
    await Promise.all(promises);

    return result;
}

async function loadKsiega(ksiega: string, database: string) {
    const response = await fetch(`ksiegi/${database}/${ksiega}`);
    const xml = await response.text();
    const json = parse(xml);

    return json["ks:Dokument"]["ks:TrescDokumentu"]["ks:TrescPodmiot"];
}

function Podmiot(props: { data: any }) {
    const data: any  = {};
    let acreditation;

    for(const key in props.data) {
        const value = props.data[key];

        if (key === "typ:AdresSiedzibyZamieszkania") {
            data[key] = getAddress(value);
            continue;
        }

        if (key === "typ:Danekontaktowe") {
            data[key] = getContact(value);
            continue;
        }

        if (key === "typ:ListaAkredytacjiKsztalcenie" && typeof value === "object") {
            acreditation = getAcreditaion(value["typ:Akredytacja"]);
            continue;
        }

        if (!value || typeof value === "object" || key == "typ:SystemZabezpieczeniaOpiekiZdrowotnej") {
            continue;
        }

        data[key] = value;
    }

    return <div>
        <div style="display: flex">
            {Object.entries(data).map(([key, value]) =>
                <div style="margin: 5px">
                    <div style="font-weight: bold">{key.substr(4)}</div>
                    <div>{value as any}</div>
                </div>
            )}
        </div>
        {acreditation ? <div style="margin-top: 10px">
            {acreditation}
        </div>: null}
    </div>;
}

function EmailAddresses(props: { data: any[] }) {
    if (!Array.isArray(props.data)) {
        props.data = [props.data];
    }

    const emails = props.data.map(v => v["typ:Danekontaktowe"]["adr:Email"]).filter(onlyUnique);

    return <div>
        {emails.map(em => <div>{em}</div>)}
    </div>;
}

function onlyUnique(value: any, index: number, self: any) {
    return self.indexOf(value) === index;
}

function PhoneNumbers(props: { data: any[], addName?: boolean }) {
    if (!Array.isArray(props.data)) {
        props.data = [props.data];
    }

    const phoneNumbers = props.data.map(v => {
        const phone = v["typ:Danekontaktowe"]["adr:Telefon"];

        if (typeof phone === "string") {
            return fixPhoneNumber(phone);
        }

        return "";
    }).filter(onlyUnique);

    return <div>
        {phoneNumbers.map(pn => <div>{pn}</div>)}
    </div>;
}

function Jednostka(props: { data: any }) {
    return <div>
        {Object.entries(props.data).map(([key, value]) => <div>
            <div>{key}</div>
            <div>{value as any}</div>
        </div>)};
    </div>
}


function JednostkaList(props: { data: any[] }) {
    if (!Array.isArray(props.data)) {
        props.data = [props.data];
    }

    const data: string[][] = [];
    const headers: {
        title: string,
        fnCreatedCell?: (td: HTMLTableDataCellElement, sData: any, oData: any[], iRow: number, iCol: number) => void
    }[] = [];

    for (let i = 0; i < props.data.length; i++) {
        const jednostka = props.data[i];
        const result = [];

        for (const key in jednostka) {
            let value = jednostka[key];

            if (key.startsWith("typ:ListaCzasowychZawieszen") || key.startsWith("typ:ZakresSwiadczen") || key.startsWith("typ:Teryt") || key.startsWith("typ:DataZakonczeniaDzialalnosci")) {
                continue;
            }

            if (key === "typ:DataRozpoczeciaDzialalnosci") {
                value = `od ${value} do ${jednostka["typ:DataZakonczeniaDzialalnosci"]}`;
            }

            if (key === "typ:Danekontaktowe") {
                if (!headers.find(v => v.title === "Telefon")) {
                    headers.push({ title: "Telefon" });
                }

                if (!headers.find(v => v.title === "Adres email")) {
                    headers.push({ title: "Adres email" });
                }

                if (!headers.find(v => v.title === "Strona www")) {
                    headers.push({ title: "Strona www" });
                }

                result.push(fixPhoneNumber(value["adr:Telefon"]));
                result.push(value["adr:Email"]);
                result.push(value["adr:URIKontakt"]);
                continue;
            }

            if (!headers.find(v => v.title === key.substr(4))) {
                headers.push({ title: key.substr(4) });
            }

            if (key === "typ:Adres") {
                value = getAddress(value);
            }

            result.push(value);
        }

        // if (!headers.find(v => v.title === "Komorki")) {
        //     headers.push({
        //         title: "Komorki",
        //         fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
        //             $(nTd).html("<a href='/cells.html?id=" + oData[4] + "'>Komórki</a>");
        //         }
        //     });
        // }

        // result.push("Komorka");

        data.push(result);
    }

    return <div class="jednostka-list">
        <table class="display compact" ref={(ref) => $(ref as HTMLTableElement).DataTable({ data: data, pageLength: 100, columns: headers })}></table>
    </div>;
}

function KomorkaList(props: { data: any[] }) {
    const data: string[][] = [];
    const headers: string[] = [];

    for (let i = 0; i < props.data.length; i++) {
        const komorka = props.data[i];
        const result = [];

        for (const key in komorka) {
            let value = komorka[key];

            if (key.startsWith("typ:LiczbaLozek") || key.startsWith("typ:LiczbaInkubatorow") || key.startsWith("typ:LiczbaStanowiskDializ") || key.startsWith("typ:LiczbaMiejscDziennych") || key.startsWith("typ:ListaCzasowychZawieszen") || key.startsWith("typ:Teryt")) {
                continue;
            }

            if (headers.indexOf(key) < 0) {
                headers.push(key);
            }

            if (key === "typ:Adres") {
                value = getAddress(value);
            }

            if (key === "typ:Danekontaktowe") {
                value = getContact(value);
            }

            result.push(value);
        }

        data.push(result);
    }

    return <div class="komorka-list">
        <table class="display compact" ref={(ref) => $(ref as HTMLTableElement).DataTable({ data: data, columns: headers.map(v => ({ title: v })})}></table>
    </div>;
}

function Komorka(props: { data: any }) {

    return <div>
        {Object.entries(props.data).map(([key, value]) => {
            if (key.startsWith("typ:LiczbaLozek")) {
                return null;
            }

            return <div>
                <div>{key}</div>
                <div>{value as any}</div>
            </div>;
        })}
    </div>;
}

function getAddress(obj: any) {
    return `${obj["adr:KodPocztowy"]} ${obj["adr:Miejscowosc"]} ${obj["adr:Ulica"]} ${obj["adr:Budynek"]} ${obj["adr:Lokal"]}`;
}


function getContact(obj: any) {
    return `${obj["adr:Email"]} ${fixPhoneNumber(obj["adr:Telefon"])} ${obj["adr:URIKontakt"]}`;
}

function getAcreditaion(obj: any[] | object) {
    if (!Array.isArray(obj)) {
        obj = [obj];
    }

    return obj.map(v => {
        const range = v["typ:ZakresAkredytacji"];
        let style = "";

        if (range.toLowerCase().indexOf("rehabilita") >= 0 || range.toLowerCase().indexOf("onkolog") >= 0 || range.toLowerCase().indexOf("urolog") >= 0) {
            if (range.toLowerCase().indexOf("neurolog") < 0) {
                style = "font-weight: bold";
            }
        }

        return <div style={style}>
            {`${v["typ:DataWydania"]} ${v["typ:ZakresAkredytacji"]}`};
        </div>
    });
}

function fixPhoneNumber(phone: string) {
    if (typeof phone !== "string") {
        return "";
    }

    let result = phone.replace(/\//gm, "").replace(/-/gm, "").replace(/ /gm, "").trim();

    if(result.startsWith("0")) {
        result = result.substr(1);
    }

    return result;
}